import immutable from 'object-path-immutable';

import * as types from '../constants/actionTypes';

export const defaultState = {
  rating: {
    loading: false,
    fields: {},
  },
  ratingSelf: {
    loading: false,
    fields: {},
  },
  profile: {
    loading: false,
    fields: {},
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_RULES:
      return immutable.set(state, `${action.ratingType}.fields`, action.rules);

    case types.FETCH_PROFILE_OPTIONS_ERROR:
    case types.FETCH_PROFILE_OPTIONS_SUCCESS:
      return immutable.set(state, 'profile.loading', false);

    case types.FETCH_PROFILE_OPTIONS_LOADING:
      return immutable.set(state, 'profile.loading', true);

    case types.FETCH_DRIVER_SELF_RATING_OPTIONS:
    case types.FETCH_DRIVER_RATING_OPTIONS:
      return immutable(state)
        .set('formType', action.formType)
        .set('loading', false)
        .value();

    case types.FETCH_DRIVER_SELF_RATING_OPTIONS_ERROR:
    case types.FETCH_DRIVER_SELF_RATING_OPTIONS_SUCCESS:
      return immutable.set(state, 'ratingSelf.loading', false);

    case types.FETCH_DRIVER_SELF_RATING_OPTIONS_LOADING:
      return immutable.set(state, 'ratingSelf.loading', true);

    case types.FETCH_DRIVER_RATING_OPTIONS_ERROR:
    case types.FETCH_DRIVER_RATING_OPTIONS_SUCCESS:
      return immutable.set(state, 'rating.loading', false);

    case types.FETCH_DRIVER_RATING_OPTIONS_LOADING:
      return immutable.set(state, 'rating.loading', true);

    default:
      return state;
  }
};
